import rp, { AppComponent, BaseSidebar } from "@reporting/rp-app-host";
import { css, html } from "lit";
import { customElement, query } from "lit/decorators.js";
import { msg } from "@omegagrid/localize";
import { dom, Layout } from "@omegagrid/core";
import { map } from "lit/directives/map.js";

@customElement('rp-mf-etl-sidebar-container')
export class SidebarContainer extends AppComponent {

	static styles = [...BaseSidebar.styles, css`
		.body {
			flex: 1;
			overflow: hidden;
		}

		rp-mf-analytics-contexts {
			height: 100%;
		}

		.btn-tab {
			width: 40px;
			height: 40px;
		}
	`];

	static reactiveState = true;

	@query('.body')
	body: HTMLElement;

	private _component: HTMLElement & Layout;

	private _modules: Map<string, {title: string, icon: string, component: string}>;
	get modules() {
		if (this._modules) return this._modules;
		this._modules = new Map();
		['etl', 'jobs', 'dwh'].forEach(module => {
			if (!rp.applications.items.has(module)) return;
			this._modules.set(module, {
				title: msg(module).toUpperCase(), 
				icon: module === 'etl' ? 'code' : rp.applications.items.get(module)?.info?.icon || '',
				component: module === 'etl' ? `${module}-sidebar` : module
			});
		});
		return this._modules;
	}

	constructor() {
		super();
		this.setState({
			activeTab: [...this.modules.values()][0]?.component,
			components: {}
		});
	}

	layout() {
		this._component?.layout();
	}

	_onTabClick = (e: PointerEvent) => {
		this.updateState({activeTab: (e.target as HTMLElement).dataset.component}, true);
	};

	async updated() {
		this._component = await rp.host.getComponent(this.state.activeTab as string) as HTMLElement & Layout;
		dom.empty(this.body);
		this.body.appendChild(this._component);
	}

	render = () => html`
		${this.modules.size > 1 ? html`
			<div class="head">
			${map(this.modules.values(), module => html`
				<og-bucket-button
					.text="${msg(module.title).toUpperCase()}"
					icon="${module.icon}"
					data-component="${module.component}"
					@click=${this._onTabClick}
					?active="${this.state.activeTab == module.component}">
				</og-bucket-button>
				`)}	
			</div>			
		` : ''}

		<div class="body"></div>
	`;

}
